import { ExternalLink } from "lucide-react";
import type { LessonLink } from "../types";

interface LessonLinksProps {
  links: LessonLink[];
}

const getLinkIcon = (type?: string) => {
  switch (type) {
    case "official":
      return "📘";
    case "video":
      return "🎥";
    case "article":
      return "📄";
    case "docs":
      return "📚";
    default:
      return "🔗";
  }
};

const getLinkBadge = (type?: string) => {
  switch (type) {
    case "official":
      return "Официальная";
    case "video":
      return "Видео";
    case "article":
      return "Статья";
    case "docs":
      return "Документация";
    default:
      return null;
  }
};

export const LessonLinks = ({ links }: LessonLinksProps) => {
  if (!links || links.length === 0) return null;

  return (
    <div className="my-6 border border-neutral-border rounded-xl bg-white shadow-sm p-5">
      <h3 className="text-lg font-semibold text-neutral-text mb-4">Полезные ссылки</h3>
      <div className="space-y-2">
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 p-3 rounded-lg border border-neutral-border hover:border-primary hover:bg-primary/5 transition-colors group"
          >
            <span className="text-xl">{getLinkIcon(link.type)}</span>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-medium text-neutral-text group-hover:text-primary transition">
                  {link.title}
                </span>
                {link.type && (
                  <span className="text-xs px-2 py-0.5 bg-neutral-light text-neutral-text/60 rounded">
                    {getLinkBadge(link.type)}
                  </span>
                )}
              </div>
            </div>
            <ExternalLink className="w-4 h-4 text-neutral-text/40 group-hover:text-primary transition flex-shrink-0" />
          </a>
        ))}
      </div>
    </div>
  );
};

